





























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import {
  ApplicationRecord,
  User,
  Auction,
  Lot,
  Media,
  ContactForm,
} from '@/api';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: {
    AbstractTable,
    ConfirmDialog,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  search: string = '';

  singleSelect: boolean = true;
  selected: ApplicationRecord[] = [];

  itemDeleteDialog: boolean = false;
  confirmDeleteMessage: string = '';

  // Current value of each `filter[...]` control, keyed by its server-side param
  // name. Declared up front by `resetFilters()` so every key is reactive before
  // a select touches it - assigning a new key to this object later would not be
  // observed by Vue 2.
  filterValues: { [param: string]: string } = {};

  get model() {
    switch (this.$route.name) {
      case 'admin-users':
        return User;
      case 'admin-auctions':
        return Auction;
      case 'admin-media':
        return Media;
      case 'admin-contact':
        return ContactForm;
      default:
        return ApplicationRecord;
    }
  }

  get headers() {
    return this.model.listHeaders();
  }

  get listFilters() {
    return this.model.listFilters();
  }

  get scopeFactory() {
    return this.model.scopeFactory;
  }

  get defaultOptions() {
    return this.model.defaultOptions();
  }

  get actions() {
    return [
      {
        text: 'Add an Auction',
        icon: 'mdi-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-auctions-add' });
        },
        showMe: () => this.$route.name === 'admin-auctions',
      },
      {
        text: 'Edit Auction',
        icon: 'mdi-file-document-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-auctions-edit',
              params: { auctionId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-auctions',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Auction',
        icon: 'mdi-delete',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this auction?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-auctions',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Add a User',
        icon: 'mdi-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-users-add' });
        },
        showMe: () => this.$route.name === 'admin-users',
      },
      {
        text: 'Edit User',
        icon: 'mdi-file-document-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-users-edit',
              params: { userId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-users',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'View Message',
        icon: 'mdi-eye',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-contact-view',
              params: { messageId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-contact',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Message',
        icon: 'mdi-delete',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this message?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-contact',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Media',
        icon: 'mdi-delete',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this media?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-media',
        isDisabled: this.selected.length === 0,
      },
    ];
  }

  get filteredActions() {
    return this.actions.filter(action => action.showMe());
  }

  get singleSelected() {
    return this.selected[0] || null;
  }

  itemClicked(item: ApplicationRecord) {
    if (!item.id) {
      return;
    }
    if (this.$route.name === 'admin-auctions') {
      this.$router.push({
        name: 'admin-auctions-edit',
        params: { auctionId: item.id },
      });
    } else if (this.$route.name === 'admin-users') {
      this.$router.push({
        name: 'admin-users-edit',
        params: { userId: item.id },
      });
    } else if (this.$route.name === 'admin-contact') {
      this.$router.push({
        name: 'admin-contact-view',
        params: { messageId: item.id },
      });
    }
  }

  update() {
    (this.$refs.abstractTable as AbstractTable).update();
  }

  async deleteSelectedItem() {
    if (!this.singleSelected) {
      return;
    }
    try {
      await this.singleSelected.destroy();
    } catch (err) {
      // Error
    } finally {
      this.itemDeleteDialog = false;
      this.selected = [];
      this.update();
    }
  }

  // Each filter starts on its first item, which is the "no filter" choice.
  resetFilters() {
    const values: { [param: string]: string } = {};
    this.listFilters.forEach(filter => {
      values[filter.param] = filter.items.length ? filter.items[0].value : '';
    });
    this.filterValues = values;
  }

  created() {
    this.resetFilters();
  }

  @Watch('$route.path')
  routeChanged() {
    this.search = '';
    // The list is keyed by route name and remounts, but this component does
    // not, so filters from the previous list would otherwise be sent to the
    // next endpoint - where the param name is very likely a 400.
    this.resetFilters();
  }
}
